function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M59.265 47.687l-8.077-16.164a.632.632 0 00-1.153.055l-4.557 11.834a46.725 46.725 0 00-4.235-.196c-1.411 0-2.784.07-4.125.188l-3.89-11.771a.63.63 0 00-1.153-.102l-8.673 16.03c-4.486 2.863-7.239 7.129-7.239 12.783 0 11.372 11.12 17.12 25.08 17.12 13.952 0 25.08-5.748 25.08-17.12 0-5.584-2.69-9.795-7.058-12.657z",
  fill: "#5E4537"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M72.59 24.167c1.804 1.686.682 4.156-4.486 8.258-1.435 1.137-2.83 1.67-3.882.682-1.05-.98-.745-2.604.322-4.164 3.945-5.733 6.235-6.462 8.046-4.776zm7.184 11.615c.596 2.4-1.694 3.858-8.258 4.486-1.828.172-3.287-.142-3.632-1.538-.345-1.396.793-2.588 2.541-3.31 6.44-2.681 8.753-2.038 9.349.362zM60.356 17.626c-2.44-.431-3.733 1.945-3.922 8.54-.054 1.836.361 3.263 1.78 3.514 1.42.251 2.534-.965 3.138-2.753 2.227-6.603 1.443-8.87-.996-9.3z",
  fill: "#FFE760"
});

var SvgAppiconReaction = function SvgAppiconReaction(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppiconReaction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appicon-reaction.2b17ef3a.svg";
export { ForwardRef as ReactComponent };